<p-dialog
  header="Edit Metadata"
  [modal]="true"
  [(visible)]="visible"
  (onHide)="closeDialog()"
  [style]="{ width: '40rem' }"
>
  <span class="dialog-subtitle">Update the document information and metadata.</span>

  <form #metaForm="ngForm" class="form-container">
    <div class="form-field">
      <label for="category" class="form-label">Category</label>
      <input
        pInputText
        id="category"
        name="category"
        [(ngModel)]="formData.category"
        class="form-input"
        autocomplete="off"
        placeholder="e.g. Invoices"
      />
    </div>

    <div class="form-field">
      <label for="year" class="form-label">Year</label>
      <input
        pInputText
        id="year"
        name="year"
        [(ngModel)]="formData.year_of_publication"
        class="form-input"
        autocomplete="off"
        placeholder="e.g. 2024"
        [pattern]="yearPattern"
        #year="ngModel"
      />
      @if (year.invalid && year.dirty) {
        <small class="error-text">Please enter a valid 4-digit year.</small>
      }
    </div>

    <div class="form-field full-width">
      <label for="description" class="form-label">Description</label>
      <textarea
        pTextarea
        id="description"
        name="description"
        [(ngModel)]="formData.description"
        class="form-input"
        [rows]="4"
        placeholder="Brief description of the document..."
      ></textarea>
    </div>

    <div class="form-field full-width">
      <label for="link" class="form-label">Link</label>
      <input
        pInputText
        id="link"
        name="link"
        [(ngModel)]="formData.link"
        class="form-input"
        autocomplete="off"
        placeholder="https://..."
        [pattern]="urlPattern"
        #link="ngModel"
      />
      @if (link.invalid && link.dirty) {
        <small class="error-text">Please enter a valid URL (e.g. https://example.com).</small>
      }
    </div>

    <div class="form-field full-width">
      <label for="keywords" class="form-label">Keywords</label>
      <input
        pInputText
        id="keywords"
        name="keywords"
        [(ngModel)]="formData.keywordsStr"
        class="form-input"
        autocomplete="off"
        placeholder="tag1, tag2, tag3"
      />
      <span class="form-hint">Separate keywords with commas (e.g. finance, report, q3)</span>
    </div>
  </form>

  <div class="dialog-actions">
    <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="closeDialog()" />
    <p-button label="Save Changes" [disabled]="metaForm.invalid === true" (onClick)="onSave()" />
  </div>
</p-dialog>
